@if (isRefreshedSolutionParticipationUIEnabled) {
    <!-- Neptune filter/export control bar -->
  <section class="flex items-center justify-between w-full mb-3" id="sp-location-view-controls">
    <!-- Don't show radios for QSR/FRS or non-NA/IMEA regions and when multi-region is selected -->
    @if (!shouldHideRebateMplSplColumns) {
    <div class="flex items-center gap-6" id="sp-location-widget-type-filter">
      @for (type of widgetTypes; track type.value) {
      <div class="flex items-center">
        <input type="radio" name="sp-widget-type" class="size-4 accent-blue cursor-pointer disabled:cursor-not-allowed"
          [id]="'sp-widget-type-' + type.value" [value]="type.value" [checked]="selectedWidgetType === type.value"
          (change)="onWidgetTypeChange(type.value)" [disabled]="isLoading || (oneCustomerName !== '' && type.value !== 'all')">
        <label [for]="'sp-widget-type-' + type.value"
          class="flex items-center gap-1.5 ml-1.5 text-sm text-neptune-neutral cursor-pointer"
          [ngClass]="{'opacity-40 cursor-not-allowed': isLoading || (oneCustomerName !== '' && type.value !== 'all')}">
          <span class="size-3.5 inline-block" [ngClass]="getWidgetColorClass(type.class)"></span>
          {{type.label}}
        </label>
      </div>
      }
    </div>
    }
    <div class="flex justify-end ml-auto" id="sp-location-export-table-btn">
      @if (isLoading) {
      <div class="bg-gray flex items-center gap-2 px-4 py-2 rounded-md animate-pulse">
        <div class="w-4 h-4 bg-gray rounded"></div>
        <div class="w-24 h-4 bg-gray rounded"></div>
      </div>
      } @else {
      <button type="button" id="export-table-button" (click)="exportAllToExcel()"
        class="flex items-center gap-2 rounded-md bg-blue text-white text-sm font-medium px-4 py-2 cursor-pointer disabled:opacity-50"
        [disabled]="fileDownload">
        @if (!fileDownload) {
        <img src="assets/export-table-icon.svg" alt="export-table-icon" />
        } @else {
        <span class="loader-sm"></span>
        }
        <span>Export Table</span>
      </button>
      }
    </div>
  </section>

  <!-- Multiple-contract + non-'all' widget selection replaces the complete Location View details area with the hierarchy warning below -->
  @if (multipleContractsSelected && selectedWidgetType !== 'all') {
    <!-- Handle Message for widgets when Multiple Accounts are selected -->
    <div class="flex flex-col items-center justify-center min-h-[89px] w-full text-base leading-6 font-normal text-neptune-default text-center" id="location-view-multi-account-message">
      {{multipleHierarchiesSelectedMessage}}
    </div>
  } @else {

  <!-- Hide the progress bar, tabs, search/filters/paginator controls once loading has finished and the plain "No Data Available" state applies (single contract, no multiple rebates, and not the Rebate-ineligible message case) -->
  @if (showTableLoader ||
       filteredLocationsData.length ||
       multipleContractsSelected ||
       multipleRebatesExistForContract ||
       (selectedWidgetType === 'rebate' && !eligibleForRebate)) {
 <ng-container id="sp-header-bar-graph-section" class="py-6">
  <app-location-overview-gauge-chart></app-location-overview-gauge-chart>
 </ng-container>
  <!-- Neptune Compliance/Sales/Cases tab group hidden for the multi-contract + MPL/SPL/Rebate message-only scenario -->
  @if (!isLoading) {
  @if (!(multipleContractsSelected && selectedWidgetType !== 'all')) {
  <section class="pt-6">
    <div class="flex items-center p-1 mb-4 rounded-full border border-solid border-blue" id="sp-location-view-tabs">
      <button type="button" id="sp-location-compliance-tab" data-id="compliance-view-tab"
        class="flex-1 h-[37px] rounded-full px-5 py-2 text-sm font-medium leading-[21px] cursor-pointer"
        [ngClass]="tabSelected === 'compliance' ? 'bg-blue text-white shadow-neptune-elevation-1' : 'bg-transparent text-neptune-neutral'"
        [attr.aria-pressed]="tabSelected === 'compliance'" (click)="changeTab('compliance')">
        Compliance
      </button>
      <button type="button" id="sp-location-sales-tab" data-id="sales-view-tab"
        class="flex-1 h-[37px] rounded-full px-5 py-2 text-sm font-medium leading-[21px] cursor-pointer"
        [ngClass]="tabSelected === 'sales' ? 'bg-blue text-white shadow-neptune-elevation-1' : 'bg-transparent text-neptune-neutral'"
        [attr.aria-pressed]="tabSelected === 'sales'" (click)="changeTab('sales')">
        Sales
      </button>
      <button type="button" id="sp-location-cases-tab" data-id="cases-view-tab"
        class="flex-1 h-[37px] rounded-full px-5 py-2 text-sm font-medium leading-[21px] cursor-pointer"
        [ngClass]="tabSelected === 'cases' ? 'bg-blue text-white shadow-neptune-elevation-1' : 'bg-transparent text-neptune-neutral'"
        [attr.aria-pressed]="tabSelected === 'cases'" (click)="changeTab('cases')">
        Cases
      </button>
    </div>
  </section>

<div class="relative flex items-center w-full">
  <!-- Left Section -->
  <div class="flex items-center basis-1/3">
    <div
      id="sp-location-search-box"
      class="flex items-center gap-3 h-8 w-64 px-4 py-2 rounded-md border border-solid border-neptune-color-fg-muted" >
     <img src="assets/gray-search-icon.png" class="size-4" alt="search-icon" />
      <input
        type="text"
        id="location-view-search-input"
        placeholder="Search Location"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearch(searchTerm)"
        (focus)="onSearchFocus()"
        (blur)="onSearchBlur()"
        class="border-none outline-none h-full w-full flex-1 min-w-0 bg-transparent text-base leading-6 text-neptune-neutral placeholder:text-neptune-neutral focus:outline-none"
      />
    </div>
  </div>

  <!-- Center Section: trigger button; dropdown overlay below is anchored to the full row, not just this column -->
  <div class="flex justify-center basis-1/3">
    @if (!displayLoaderForFilterData) {
    <div
      id="sol-part-advanced-filters"
    >
      <advanced-filters
        [advancedFilterData]="advancedFilterData"
        [pageScope]="'Solution participation location view'"
        [selectedAdvancedFilters]="productSelectedAdvancedFilters"
        [filterGroupings]="filterGroupings"
        (selectedFilters)="onSelectedFiltersChange($event)"
        [(toggleBody)]="toggleAdvancedFilterSelection"
        [useRefreshedUi]="true"
      >
      </advanced-filters>
    </div>
    }
  </div>

  <!-- Right Section: Neptune custom paginator -->
  <div class="flex justify-end basis-1/3">
    <div class="flex items-center gap-4 text-sm text-neptune-color-fg-muted" id="sg-locations-paginator">
      <div class="flex items-center gap-2">
        <label for="sg-paginator-page-label" class="whitespace-nowrap">Items per page:</label>
        <div class="relative">
          <select
            id="sg-paginator-page-size"
            aria-label="Items per page"
            class="appearance-none rounded-md border border-solid border-neptune-border-subtle bg-white pl-3 pr-7 py-1 text-sm text-neptune-default cursor-pointer focus:outline-none focus:border-blue"
            (change)="onPageSizeChange(+$any($event.target).value)">
            @for (size of pageSizeOptions; track size) {
            <option [value]="size" [selected]="size === paginationOptions.limit">{{size}}</option>
            }
          </select>
          <img src="assets/shared-icons/neptune-icon-black-chevron-down.svg" alt="" class="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 size-3" />
        </div>
      </div>

      <span class="whitespace-nowrap" id="sg-paginator-range" aria-label="Page range">{{startRecord}}-{{endRecord}} of {{totalLocationsCount}}</span>

    <div class="flex items-center gap-1">
      <!-- First -->
      <button type="button" id="sg-paginator-first" aria-label="First page" [disabled]="isFirstPage" (click)="firstPage()"
        class="flex items-center justify-center size-6
              rounded bg-transparent
              hover:bg-gray-100
              disabled:cursor-not-allowed
              cursor-pointer">
        <img src="assets/shared-icons/neptune-icon-black-chevron-left.svg" alt="" class="size-3" />
        <img src="assets/shared-icons/neptune-icon-black-chevron-left.svg" alt="" class="size-3 -ml-2" />
      </button>

      <!-- Previous -->
      <button type="button" id="sg-paginator-previous" aria-label="Previous page" [disabled]="isFirstPage"
        (click)="previousPage()" class="flex items-center justify-center size-6
              rounded bg-transparent
              hover:bg-gray-100
              disabled:cursor-not-allowed
              cursor-pointer">
        <img src="assets/shared-icons/neptune-icon-black-chevron-left.svg" alt="" class="size-3.5" />
      </button>

      <!-- Next -->
      <button type="button" id="sg-paginator-next" aria-label="Next page" [disabled]="isLastPage" (click)="nextPage()"
        class="flex items-center justify-center size-6
              rounded bg-transparent
              hover:bg-gray-100
              disabled:cursor-not-allowed
              cursor-pointer">
        <img src="assets/shared-icons/neptune-icon-blue-chevron-right.svg" alt="" class="size-3.5" />
      </button>

      <!-- Last -->
      <button type="button" id="sg-paginator-last" aria-label="Last page" [disabled]="isLastPage" (click)="lastPage()"
        class="flex items-center justify-center size-6
              rounded bg-transparent
              hover:bg-gray-100
              disabled:cursor-not-allowed
              cursor-pointer">
        <img src="assets/shared-icons/neptune-icon-blue-chevron-right.svg" alt="" class="size-3" />
        <img src="assets/shared-icons/neptune-icon-blue-chevron-right.svg" alt="" class="size-3 -ml-2" />
      </button>
    </div>
    </div>
  </div>

  <!-- Dropdown overlay for the Advanced Filters button: spans the full row width, scoped to this usage only -->
  @if (toggleAdvancedFilterSelection) {
  <advanced-filters-selection
    class="absolute left-0 right-0 top-full z-50 block bg-white border border-solid border-neptune-border-subtle rounded-md shadow-neptune-elevation-2"
    [advancedFilterData]="advancedFilterData"
    [excludeKeys]="excludeKeys"
    [pageScope]="'Solution participation location view'"
    [selectedAdvancedFilters]="productSelectedAdvancedFilters"
    [filterGroupings]="filterGroupings"
    (selectedFilters)="onSelectedFiltersChange($event)"
    [(toggleBody)]="toggleAdvancedFilterSelection"
  >
  </advanced-filters-selection>
  }
</div>
   }
} @else {
<!-- Skeleton for the tabs + search/filters/paginator controls while table data is loading -->
  <section class="pt-6">
    <div class="h-[45px] rounded-full bg-neptune-subtle animate-pulse" id="sp-location-view-tabs-skeleton"></div>
  </section>
  <div class="flex items-center w-full animate-pulse" id="sg-locations-header-skeleton">
    <div class="flex items-center basis-1/3">
      <div class="h-8 w-64 rounded-md bg-neptune-subtle"></div>
    </div>
    <div class="flex justify-center basis-1/3">
      <div class="h-10 w-40 rounded-md bg-neptune-subtle"></div>
    </div>
    <div class="flex justify-end basis-1/3">
      <div class="h-12 w-72 rounded bg-neptune-subtle"></div>
    </div>
  </div>
}

  <!-- Persistent "Filters Selected" chips row: stays visible after Apply closes the dropdown above -->
  @if (!isLoading && !toggleAdvancedFilterSelection && !displayLoaderForFilterData) {
  <advanced-filters-selection
    class="block w-full"
    [advancedFilterData]="advancedFilterData"
    [excludeKeys]="excludeKeys"
    [pageScope]="'Solution participation location view'"
    [selectedAdvancedFilters]="productSelectedAdvancedFilters"
    [filterGroupings]="filterGroupings"
    (selectedFilters)="onSelectedFiltersChange($event)"
    [toggleBody]="false"
  >
  </advanced-filters-selection>
  }
  }

  <!-- Neptune Locations Table -->
  @if (showTableLoader) {
    <div class="flex overflow-hidden rounded-md bg-white border border-neptune-border-subtle" id="sp-location-table-skeleton">
      <!-- Skeleton Left Section -->
      <div class="flex flex-col shrink-0 border-r border-neptune-border-subtle mt-1.5" [ngClass]="selectedWidgetType !== 'all' ? 'basis-2/5' : 'basis-[35%]'">
        <div class="sticky top-0 z-10 flex items-center bg-[#fafbfc] h-14">
          <div class="h-5 w-24 ml-4 rounded bg-neptune-disabled animate-pulse"></div>
          @if (selectedWidgetType !== 'all') {
          <div class="h-5 w-16 ml-auto mr-4 rounded bg-neptune-disabled animate-pulse"></div>
          }
          <div class="h-5 w-32 mr-4 rounded bg-neptune-disabled animate-pulse"></div>
        </div>
        <div>
          @for (row of skeletonRows; track $index) {
          <div class="flex items-center border-b border-neptune-border-subtle min-h-[95px] px-4">
            <div class="flex flex-col gap-2 flex-1">
              <div class="h-4 w-32 rounded bg-neptune-subtle animate-pulse"></div>
              <div class="h-3 w-40 rounded bg-neptune-subtle animate-pulse"></div>
              <div class="h-3 w-28 rounded bg-neptune-subtle animate-pulse"></div>
            </div>
            @if (selectedWidgetType !== 'all') {
            <div class="w-16 h-16 rounded-full bg-neptune-subtle animate-pulse shrink-0"></div>
            }
            <div class="w-10 h-6 rounded bg-neptune-subtle animate-pulse shrink-0 ml-4"></div>
          </div>
          }
        </div>
      </div>
      <!-- Skeleton Right Section -->
      <div class="flex-1 overflow-hidden">
        <div class="sticky top-0 z-10 flex items-center bg-[#fafbfc] h-14">
          @for (col of skeletonColumns; track $index) {
          <div class="box-border flex items-center w-[150px] min-w-[150px] max-w-[150px] shrink-0 grow-0 h-14 px-4 py-2.5">
            <div class="h-5 w-24 rounded bg-neptune-disabled animate-pulse"></div>
          </div>
          }
        </div>
        <div>
          @for (row of skeletonRows; track $index) {
          <div class="flex items-center border-b border-neptune-border-subtle min-h-[95px]">
            @for (col of skeletonColumns; track $index) {
            <div class="flex items-center justify-center min-w-[150px] max-w-[150px]">
              <div class="w-8 h-8 rounded bg-neptune-subtle animate-pulse"></div>
            </div>
            }
          </div>
          }
        </div>
      </div>
    </div>
  } @else {
    @if (filteredLocationsData.length) {
    <div class="flex overflow-hidden rounded-md bg-white border border-neptune-border-subtle text-xs font-sans" id="sp-location-table" [ngClass]="{'has-widget': selectedWidgetType !== 'all'}">
      <!-- Shared up/down sort indicator icons for the Purchased Solution Group column and each dynamic solution group column -->
      <ng-template #sortArrowIcons let-column="column">
        <img src="assets/blue-arrow.svg" alt="sort-arrow-up" class="w-2.5 h-2.5"
          [ngClass]="sortBy === column && sortDirections[column] === 'asc' ? 'opacity-100' : 'opacity-30'" />
        <img src="assets/blue-arrow.svg" alt="sort-arrow-down" class="w-2.5 h-2.5 rotate-180"
          [ngClass]="sortBy === column && sortDirections[column] === 'desc' ? 'opacity-100' : 'opacity-30'" />
      </ng-template>
      @if (((multipleContractsSelected && selectedWidgetType === 'all') ||
                     (!multipleContractsSelected && !eligibleForRebate && selectedWidgetType === 'all') ||
                     (!multipleContractsSelected && eligibleForRebate)) &&
                     !(multipleRebatesExistForContract === true && selectedWidgetType === 'rebate')) {
        <!-- Left Fixed Section: mt-1.5 reserves the same space the right section's scrollbar takes, so both headers stay aligned -->
        <div class="left-section flex flex-col shrink-0 border-r border-neptune-border-subtle mt-1.5" [ngClass]="selectedWidgetType !== 'all' ? 'basis-2/5' : 'basis-[35%]'">
          <div id="location-view-table-header-left" class="sticky top-0 z-10 flex items-center bg-[#fafbfc] text-neptune-default text-[12px] leading-4 font-normal h-14 overflow-hidden">
            <div class="header-column flex items-center pl-4 cursor-pointer" [ngClass]="selectedWidgetType !== 'all' ? 'w-1/2' : 'w-[70%]'" [class.text-blue]="sortBy === 'siteId'" [class.bg-neptune-color-primary-50]="sortBy === 'siteId'">
              Location
              <span class="sort-arrow flex flex-col items-center justify-center gap-[1px] shrink-0 pl-2" id="location-view-location-sort-icon" [attr.data-id]="'sort-arrow-location'" (click)="toggleSortDirection('siteId')">
                <ng-container *ngTemplateOutlet="sortArrowIcons; context: {column: 'siteId'}"></ng-container>
              </span>
            </div>
            @if (selectedWidgetType !== 'all') {
            <div class="header-column flex items-center w-[30%] pl-5">
              <span>{{getWidgetColumnName(selectedWidgetType)}}</span>
            </div>
            }
            <div class="header-column flex items-center pr-4 text-neptune-default" id="purchased-solution-group-header" [ngClass]="selectedWidgetType !== 'all' ? 'w-1/5 pl-2.5' : 'w-[30%] pl-2.5'">
               <span>Purchased Solution Group</span>
                <span class="sort-arrow flex flex-col items-center justify-center gap-[1px] shrink-0" id="purchased-solution-group-sort-icon" [attr.data-id]="'sort-arrow-location'" (click)="toggleSortDirection('countPurchased')">
                  <ng-container *ngTemplateOutlet="sortArrowIcons; context: {column: 'countPurchased'}"></ng-container>
                </span>
            </div>

          </div>

          <div>
            @for (location of filteredLocationsData; track location.siteId; let i = $index) {
              <div class="locations-table-row flex items-center px-4 bg-white border-b border-neptune-border-subtle min-h-[95px]" [id]="'location-table-row-left-'+ i">
                <!-- Location block -->
                <div class="flex flex-col items-start justify-center text-neptune-default text-[12px] font-normal leading-4" [ngClass]="selectedWidgetType !== 'all' ? 'w-1/2 pr-2.5' : 'w-[70%]'">
                  <div class="location-name text-sm text-blue font-bold">{{location?.siteName! | capitalize}},</div>
                  <div class="address-line-1">{{location?.address}},</div>
                  <div><span class="city-state">{{location?.city! | capitalize}}, {{location.state}}</span>, <span class="country-zip">{{location?.country}} - {{location?.zipCode}}</span></div>
                </div>

                <!-- Widget Bar Graph block -->
                @if (this.selectedWidgetType !== 'all') {
                <div class="w-[30%] flex justify-center items-start mt-2.5 middle-text">
                  <app-widget-bar-graph
                    [attr.id]="'compliance-progress-bar-' + location.siteId"
                    [widgetType]="getLocationBarGraphType(selectedWidgetType)"
                    [value]="selectedWidgetType === 'rebate' ? location.count : location.greenCount"
                    [total]="solutionGroupNames.length"
                    [targetValue]="selectedWidgetType === 'rebate' ? location.compliance : undefined"
                    [displayText]="getCustomMiddleText(location, solutionGroupNames.length, selectedWidgetType)">
                  </app-widget-bar-graph>
                </div>
                }

                <!-- Solution Groups block -->
                <div class="flex items-center justify-center" [ngClass]="selectedWidgetType !== 'all' ? 'w-1/5' : 'w-[30%]'" (click)="openLocationSolutionsModal(location.siteId, location.siteName, location.count, this.selectedWidgetType, true, '')">
                  <div class="counts-box flex flex-col items-center gap-0.5 w-max p-2 rounded-[10px] border border-solid border-blue text-blue cursor-pointer hover:bg-blue hover:text-white" [ngClass]="{'cursor-pointer': location}">
                    <div class="sg-count text-base font-bold leading-normal text-center w-full">{{location?.count}}</div>
                    <div class="text-[10px] font-normal leading-normal tracking-[-0.1px] text-center w-full">Groups</div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        <!-- Right Scrollable Section: fixed slim scrollbar so its reserved height always matches the left section's mt-1.5 offset -->
        <div #rightSection class="right-section horizontal-scrollable flex-1 overflow-x-auto overflow-y-hidden bg-white [&::-webkit-scrollbar]:h-1.5 [&::-webkit-scrollbar-track]:bg-neptune-subtle [&::-webkit-scrollbar-thumb]:bg-blue [&::-webkit-scrollbar-thumb]:rounded-full" [ngClass]="selectedWidgetType !== 'all' ? 'basis-3/5' : 'basis-[65%]'" style="transform: rotateX(180deg);">
          <!-- Table contents -->
          <div class="table-contents" style="transform: rotateX(180deg);">
            @for (location of filteredLocationsData; track location.siteId; let j = $index) {
              <div class="locations-table-row flex min-w-fit bg-white border-b border-neptune-border-subtle min-h-[95px]" [id]="'location-table-row-right'+ j">
                <div class="sg-status flex justify-center">
                  @for (solutionGroup of solutionGroupNames; track solutionGroup; let i = $index) {
                   <!-- Solution Groups block -->
                    <div class="solution-status box-border flex flex-col justify-center items-center w-[150px] min-w-[150px] max-w-[150px] shrink-0 grow-0 transition-all duration-300 cursor-pointer"
                      [ngClass]="{'bg-blue text-white': hoveredRowIndex === j && hoveredCellIndex === i}"
                      (mouseenter)="hoveredRowIndex = j; hoveredCellIndex = i"
                      (mouseleave)="hoveredRowIndex = null; hoveredCellIndex = null"
                      (click)="openLocationSolutionsModal(location.siteId, location.siteName, location.count, this.selectedWidgetType, false, solutionGroup)"
                    >
                      <!-- Regular status icon/text set -->
                      @if (!(hoveredRowIndex === j && hoveredCellIndex === i)) {
                        @switch (tabSelected) {
                          @case ('compliance') {
                            @switch (location.solutions[solutionGroup].status) {
                              @case ('Green') { <img src="assets/solution-participation/check-icon.svg" alt="green-checkmark-icon" class="status-icon w-4 green-icon"> }
                              @case ('Yellow') { <img src="assets/solution-participation/warning-icon.svg" alt="yellow-warning-icon" class="status-icon w-4 yellow-icon"> }
                              @case ('Red') { <img src="assets/solution-participation/close-icon.svg" alt="red-cross-icon" class="status-icon w-4 red-icon"> }
                            }
                          }

                          @case ('sales') {
                            <div class="text-[22px] sales-value">
                              {{ (location.solutions[solutionGroup].sales || 0) === '0' ? '-' : (currencyCode | currencySymbol) + (location.solutions[solutionGroup].sales | number:'1.0-0') }}
                            </div>
                          }

                          @case ('cases') {
                            <div class="text-[22px] cases-value">
                              {{ (location.solutions[solutionGroup].cases || 0) === '0' ? '-' : (location.solutions[solutionGroup].cases | number:'1.0-0') }}
                            </div>
                          }
                        }
                      }

                      <!-- White status icon/text sets on hover -->
                      @if (hoveredRowIndex === j && hoveredCellIndex === i) {
                        <div class="pt-5">
                          @switch (tabSelected) {
                            @case ('compliance') {
                              @switch (location.solutions[solutionGroup].status) {
                                @case ('Green') { <img src="assets/solution-participation/check-icon-white.svg" alt="white-checkmark-icon" class="w-4"> }
                                @case ('Yellow') { <img src="assets/solution-participation/warning-icon-white.svg" alt="white-warning-icon" class="w-4"> }
                                @case ('Red') { <img src="assets/solution-participation/close-icon-white.svg" alt="white-cross-icon" class="w-4"> }
                              }
                            }

                            @case ('sales') {
                              <div class="text-[22px] sales-value">
                                {{ (location.solutions[solutionGroup].sales || 0) === '0' ? '-' : (currencyCode | currencySymbol) + (location.solutions[solutionGroup].sales | number:'1.0-0') }}
                              </div>
                            }

                            @case ('cases') {
                              <div class="text-[22px] cases-value">
                                {{ (location.solutions[solutionGroup].cases || 0) === '0' ? '-' : (location.solutions[solutionGroup].cases | number:'1.0-0') }}
                              </div>
                            }
                          }
                        </div>

                        <div class="white-expand-icon">
                          <img src="assets/solution-participation/chevron-down-white.svg" alt="chevron-icon" class="w-4">
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>

          <!-- Table header Right section - placed after content so the scrollbar renders on top (rotateX hack) -->
          <div class="flex items-center bg-[#fafbfc] h-14" id="location-view-table-header-right" style="transform: rotateX(180deg);">
            @for (solutionGroup of solutionGroupNames; track solutionGroup) {
              <div class="header-section box-border flex items-center w-[150px] min-w-[150px] max-w-[150px] shrink-0 grow-0 h-14 px-4 py-2.5 cursor-pointer">
                <div class="header-column inline-flex items-center gap-4">
                  <div class="solution-name text-[12px] leading-4 font-normal text-neptune-default" [class.text-blue]="sortBy === solutionGroup">
                    {{ solutionGroup }}
                  </div>

                  <span class="flex flex-col items-center justify-center gap-[1px] shrink-0"
                    [attr.data-id]="'sort-arrow-solution-group-j'" (click)="toggleSortDirection(solutionGroup)">
                    <ng-container *ngTemplateOutlet="sortArrowIcons; context: {column: solutionGroup}"></ng-container>
                  </span>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
    } @else {
    <!-- Handle the case where No Data is available -->
    @if (!multipleContractsSelected && !multipleRebatesExistForContract) {
      <div class="flex items-center justify-center min-h-[100px] w-full text-sm text-dark-gray shadow-[0_5px_7px_0_rgba(100,100,111,0.3)]" id="location-view-empty-state">
        No Data Available
      </div>
    }
    }

    <!-- Handle Message for Rebate when there are No Agreements -->
    @if (!multipleContractsSelected && !eligibleForRebate && selectedWidgetType == 'rebate') {
      <div class="flex items-center justify-center min-h-[100px] w-full text-sm text-dark-gray" id="location-view-rebate-no-agreements-message">
        No Agreements - Not applicable
      </div>
    }

    <!-- Handle Message when a contract has multiple agreements -->
    @if (!multipleContractsSelected && multipleRebatesExistForContract && selectedWidgetType == 'rebate') {
      <div class="flex items-center justify-center min-h-[100px] w-full text-sm text-dark-gray" id="location-view-rebate-multiple-agreements-message">
        Rebate information is not shown because multiple rebates are associated with this item. Please contact the Finance team for details.
      </div>
    }

    <!-- Modals with static content for Total Purchased Solution Groups and Individual Solution Groups -->
    @if (showLocationViewModal) {
      <div class="fixed inset-0 z-40 bg-neptune-modal-black" (click)="closeSolutionModal()"></div>

      <!-- Individual Solution Groups modal with products for right section-->
      @if (showSolutionGroupModal) {

        <div class="fixed inset-0 z-50 flex items-center justify-center p-4" id="solution-group-modal">
          @if (!isModalDataLoading) {
          <div class="flex flex-col gap-4 items-start bg-white rounded-md shadow-neptune-elevation-2 p-8 w-[70%] max-h-[85vh] overflow-y-auto overflow-x-hidden">
            <div class="flex flex-col gap-4 w-full">
              <div id="solution-header" class="flex items-center justify-between gap-4 pb-2 w-full">
                <h2 class="selected-solution-name text-2xl leading-9 font-normal text-neptune-default break-words">{{currentSelectedGroupForSite}}</h2>
                <div class="shrink-0 size-6 cursor-pointer" id="solution-group-modal-close-button" (click)="closeSolutionModal()">
                  <img src="assets/close-icon-dark-grey.svg" alt="Close icon" class="size-6" />
                </div>
              </div>

              @if (selectedSGProductCount != 0) {
              <div class="product-overview text-sm text-neptune-color-fg-muted">
                <span class="product-count">Products: {{selectedSolutionGroupData?.countOfProducts}}</span> |
                <span class="distributor-status">Distributed by other: {{selectedSolutionGroupData?.otherDistributor ? 'Yes'
                  : 'No'}}</span>
              </div>
              }
            </div>

            <div class="border-0 border-neptune-border-subtle border-b-2 border-solid w-full"></div>

            @if (selectedSGProductCount != 0) {
            <div id="sp-loc-product-details" class="w-full max-w-full overflow-hidden">
              <app-location-product-details-table (close)="showSolutionGroupModal = false"
                [productData]="selectedSolutionGroupData?.products" [rightSection]="true" [siteId]="currentSelectedSiteId"
                [siteName]="currentSelectedSiteName" [solutionGroup]="currentSelectedGroupForSite">
              </app-location-product-details-table>
            </div>
            } @else {
            <ng-container *ngTemplateOutlet="noProductsPurchased"></ng-container>
            }
          </div>
          } @else {
          <ng-container *ngTemplateOutlet="modalLoader"></ng-container>
          }
        </div>
      }

      <!-- Total Purchased Solution Groups modal for left section-->
      @if (showTotalSolutionGroupsModal) {
        <div class="fixed inset-0 z-50 flex items-center justify-center p-4" id="total-solution-group-modal">
          <div class="flex flex-col items-start bg-white rounded-md shadow-neptune-elevation-2 p-8 w-[70%] max-h-[85vh] overflow-y-auto overflow-x-hidden">
            <div class="total-sp-modal-header flex items-center justify-between  pb-2 w-full border-0 border-b-2 border-solid">
              <h2 class="text-2xl leading-9 font-normal text-neptune-default">Solution Groups</h2>
              <div class="shrink-0 size-6 cursor-pointer" id="total-solution-group-modal-close-button" (click)="closeSolutionModal()">
                <img src="assets/close-icon-dark-grey.svg" alt="Close icon" class="size-6" />
              </div>
            </div>

            @if (!isModalDataLoading) {
            <div class="w-full">
              <app-location-total-solutions-grid (close)="closeSolutionModal()" [siteData]="totalSolutionGroupsForSiteData"
                [siteId]="currentSelectedSiteId" [siteName]="currentSelectedSiteName"
                [totalSolutionGroups]="totalSolutionGroupsPurchased">
              </app-location-total-solutions-grid>
            </div>
            } @else {
            <ng-container *ngTemplateOutlet="modalLoader"></ng-container>
            }
          </div>
        </div>
      }

      <!-- Loader for Solution Group Modal -->
      <ng-template #modalLoader>
        <div class="fixed inset-0 z-50 flex items-center justify-center p-4" id="solution-group-modal-loader">
          <div class="flex flex-col gap-4 items-start bg-white rounded-md shadow-neptune-elevation-2 p-8 w-[70%] max-h-[85vh] overflow-y-auto overflow-x-hidden">
            <div class="flex items-center justify-between gap-4 pb-2 w-full h-[44px] shrink-0">
              <div class="h-6 w-48 rounded bg-neptune-subtle"></div>
              <div class="size-6 rounded bg-neptune-subtle shrink-0 animate-pulse"></div>
            </div>
            <div class="flex flex-col gap-3 w-full">
              @for (row of skeletonRows; track $index) {
              <div class="h-10 w-full rounded bg-neptune-subtle animate-pulse"></div>
              }
            </div>
          </div>
        </div>
      </ng-template>

      <!-- No Products Purchased for individual solution group-->
      <ng-template #noProductsPurchased>
        <div class="flex items-center justify-center min-h-[120px] w-full text-center text-neptune-color-fg-muted" id="solution-group-modal-empty-state">
          <h2 class="no-products-purchased text-base font-normal">No sales data for this solution group for the time period selected.</h2>
        </div>
      </ng-template>
    }
  }
  }

}

<div *ngIf="!isRefreshedSolutionParticipationUIEnabled" class="legacy-solution-groups-table-container">
<section class="sol-groups-table-section" id="sol-groups-table-section">
  <div class="sg-tabs-container">
    <div class="sg-tab hover-pointer" data-id="compliance-view-tab" [ngClass]="{'selectedTab': tabSelected === 'compliance'}" (click)="changeTab('compliance')">
      Compliance
    </div>
    <div class="sg-tab hover-pointer" data-id="sales-view-tab" [ngClass]="{'selectedTab': tabSelected === 'sales'}" (click)="changeTab('sales')">
      Sales
    </div>
    <div class="sg-tab hover-pointer" data-id="cases-view-tab" [ngClass]="{'selectedTab': tabSelected === 'cases'}" (click)="changeTab('cases')">
      Cases
    </div>
  </div>
  <div id="search-row">
    <div class="search-box">
        <img src="assets/gray-search-icon.png" class="search-icon" alt="search-icon">
        <input placeholder="Search Location" [(ngModel)]="searchTerm" (ngModelChange)="onSearch(searchTerm)"
        (focus)="onSearchFocus()" (blur)="onSearchBlur()">
    </div>
    <div *ngIf="!isLoading" class="exporttable-btn" (click)="exportAllToExcel()">
      <div class="export-icon">
        <span *ngIf="!fileDownload">
          <img src="assets/export-table-icon.svg" alt="export-table-icon" />
        </span>
        <span *ngIf="fileDownload">
          <span class="loader-sm"></span>
        </span>
      </div>
      <span>Export Table</span>
    </div>
  </div>
<loader [size]="'small'" *ngIf="displayLoaderForFilterData"></loader>
<div id="sol-part-advanced-filters" *ngIf="!displayLoaderForFilterData" class="neptune-advanced-filters">
              <advanced-filters
                [advancedFilterData]="advancedFilterData"
                [pageScope] = "'Solution participation location view'"
                [selectedAdvancedFilters] = "productSelectedAdvancedFilters"
                [filterGroupings]="filterGroupings"
                (selectedFilters) = "onSelectedFiltersChange($event)"
                [(toggleBody)]="toggleAdvancedFilterSelection"
                [useRefreshedUi]="true"
             >  </advanced-filters>
             <advanced-filters-selection
                [advancedFilterData]="advancedFilterData"
                [excludeKeys]="excludeKeys"
                [pageScope]="'Solution participation location view'"
                [selectedAdvancedFilters]="productSelectedAdvancedFilters"
                [filterGroupings]="filterGroupings"
                (selectedFilters)="onSelectedFiltersChange($event)"
                [(toggleBody)]="toggleAdvancedFilterSelection"
              >
              </advanced-filters-selection>
</div>
  <!-- Paginator section -->
  <div class="sol-part-filter-pagination">
    <!-- Don't show radios for QSR/FRS or non-NA/IMEA regions and when multi-region is selected -->
    <div class="radio-buttons-container" *ngIf="!shouldHideRebateMplSplColumns">
      <div *ngFor="let type of widgetTypes" [class]="type.class + '-radio'">
        <input type="radio"
               [id]="type.value"
               [value]="type.value"
               [checked]="selectedWidgetType === type.value"
               (change)="onWidgetTypeChange(type.value)"
               [disabled]="isLoading || (oneCustomerName !== '' && type.value !== 'all')">
        <label [for]="type.value">
          <span class="color-block" [class]="type.class"></span>
          {{type.label}}
        </label>
      </div>
    </div>
    <mat-paginator #paginator
        id="sg-locations-paginator"
        [pageSize]="paginationOptions.limit"
        [pageIndex]="paginationOptions.page-1"
        [pageSizeOptions]="pageSizeOptions"
        aria-label="Select page"
        [length]="totalLocationsCount"
        (page)="onPageChange($event)"
        labelId="customPaginator1Label">
    </mat-paginator>
  </div>

  <!-- Table section -->
  <div class="sol-groups-table-container" *ngIf="!showTableLoader; else tableloader"  [ngClass]="{'has-widget': selectedWidgetType !== 'all'}">
    <ng-container *ngIf="filteredLocationsData.length; else noData">
      <!--
        *** Show Table when one of the below 3 conditions are true ***
        1. Multiple Contracts are selected and Widget Type is 'all'
        2. Single Contract is selected and Widget Type is 'all' and not eligible for Rebate
        3. Single Contract is selected and eligible for Rebate
        *Do not show table if multiple Rebates exist for the contract and Widget Type is 'rebate'*
      -->
      <ng-container *ngIf="((multipleContractsSelected && selectedWidgetType === 'all') ||
                     (!multipleContractsSelected && !eligibleForRebate && selectedWidgetType === 'all') ||
                     (!multipleContractsSelected && eligibleForRebate)) &&
                     !(multipleRebatesExistForContract === true && selectedWidgetType === 'rebate')"
      >
        <!-- Left Section -->
        <div class="left-section">

            <div class="header-section">
              <div class="location header-column" [ngClass]="{'sorted': sortBy === 'siteId'}">
                Location
                <span class="sort-arrow" [attr.data-id]="'sort-arrow-location'" (click)="toggleSortDirection('siteId')">
                  <img class="sort-arrow-img" [ngClass]="{'up': sortDirections['siteId'] == 'asc', 'down': sortDirections['siteId'] == 'desc' }" src="assets/blue-arrow.svg" alt="sort-arrow" />
                </span>
              </div>
              <div class="widget header-column" *ngIf="selectedWidgetType !== 'all'">
                <!-- Used span to set padding on the left -->
                <span class="widget-text">{{getWidgetColumnName(selectedWidgetType)}}</span>
              </div>
              <div class="purchased-sg header-column" [ngClass]="{'sorted': sortBy === 'countPurchased'}">
                Purchased Solution Group
                <span class="sort-arrow" [attr.data-id]="'sort-arrow-location'" (click)="toggleSortDirection('countPurchased')">
                  <img class="sort-arrow-img" [ngClass]="{'up': sortDirections['countPurchased'] == 'asc', 'down': sortDirections['countPurchased'] == 'desc' }" src="assets/blue-arrow.svg" alt="sort-arrow" />
                </span>
              </div>
            </div>

            <div class="table-contents">
                <ng-container *ngFor="let location of filteredLocationsData; let i = index;">
                  <div class="locations-table-row" [id]="'location-table-row-left-'+ i">
                    <!-- Location block -->
                    <div class="location-block">
                      <div class="address-container">
                        <div class="location-name">{{location?.siteName! | capitalize}},</div>
                        <div class="address-line-1">{{location?.address}},</div>
                        <div class="address-line-2"><span class="city-state">{{location?.city! | capitalize}}, {{location.state}}</span>, <span class="country-zip">{{location?.country}} - {{location?.zipCode}}</span></div>
                      </div>
                    </div>

                  <!-- Widget Gauge Chart block -->
                  <div class="widget-graph-block" *ngIf="this.selectedWidgetType !== 'all'">
                    <ng-container *ngIf="selectedWidgetType === 'rebate'">
                      <app-widget-gauge-chart [widgetType]="'rebate'"
                        [data]="[location.count, solutionGroupNames.length]" [colors]="getWidgetColors(selectedWidgetType)"
                        [showLabels]="false" [showNeedle]="false" [showSmallWidget]="true"
                        [showTargetLine]="true" [complianceTarget] = "location.compliance"
                        [showMiddleText]="true" [customMiddleText]="getCustomMiddleText(location, solutionGroupNames.length, selectedWidgetType)"
                        [chartConfig]="chartConfig">
                      </app-widget-gauge-chart>
                    </ng-container>
                    <!-- For MPL/SPL Widget -->
                    <ng-container *ngIf="selectedWidgetType !== 'rebate'">
                      <app-widget-gauge-chart [widgetType]="selectedWidgetType"
                        [data]="[location.greenCount, solutionGroupNames.length]" [colors]="getWidgetColors(selectedWidgetType)"
                        [showLabels]="false" [showNeedle]="false" [showSmallWidget]="true"
                        [showMiddleText]="true" [customMiddleText]="getCustomMiddleText(location, solutionGroupNames.length, selectedWidgetType)"
                        [chartConfig]="chartConfig">
                      </app-widget-gauge-chart>
                    </ng-container>
                  </div>
                    <!-- Solution Groups block -->
                    <div class="sg-counts-block" (click)="openLocationSolutionsModal(location.siteId, location.siteName, location.count, this.selectedWidgetType, true, '')">
                      <div class="counts-box" [ngClass]="{'hoverable': location}">
                        <div class="sg-count">{{location?.count}}</div>
                        <div class="sub-text">Groups</div>
                      </div>
                    </div>
                  </div>
                </ng-container>
            </div>
        </div>

        <!-- Right Section -->
        <div #rightSection class="right-section horizontal-scrollable">
          <!-- Table contents -->
          <div class="table-contents">
            <ng-container *ngIf="filteredLocationsData.length">
              <ng-container *ngFor="let location of filteredLocationsData; let j = index;">
                <div class="locations-table-row" [id]="'location-table-row-right'+ j">
                  <!-- Solution Groups Scrollable block -->
                  <div class="sg-status row">
                    <ng-container *ngFor="let solutionGroup of solutionGroupNames; let i = index">
                      <div class="solution-status"
                        [ngClass]="{'hovered': hoveredRowIndex === j && hoveredCellIndex === i}"
                        (mouseenter)="hoveredRowIndex = j; hoveredCellIndex = i"
                        (mouseleave)="hoveredRowIndex = null; hoveredCellIndex = null"
                        (click)="openLocationSolutionsModal(location.siteId, location.siteName, location.count, this.selectedWidgetType, false, solutionGroup)"
                      >
                        <!-- Regular status icon/text set -->
                        <ng-container *ngIf="!(hoveredRowIndex === j && hoveredCellIndex === i)">
                          <ng-container [ngSwitch]="tabSelected">
                            <ng-container *ngSwitchCase="'compliance'" [ngSwitch]="location.solutions[solutionGroup].status">
                              <img *ngSwitchCase="'Green'" src="assets/solution-participation/check-icon.svg" alt="green-checkmark-icon" class="status-icon green-icon">
                              <img *ngSwitchCase="'Yellow'" src="assets/solution-participation/warning-icon.svg" alt="yellow-warning-icon" class="status-icon yellow-icon">
                              <img *ngSwitchCase="'Red'" src="assets/solution-participation/close-icon.svg" alt="red-cross-icon" class="status-icon red-icon">
                            </ng-container>

                            <ng-container *ngSwitchCase="'sales'" class="sales-status">
                              <div class="sales-value">
                                {{ (location.solutions[solutionGroup].sales || 0) === '0' ? '-' : (currencyCode | currencySymbol) + (location.solutions[solutionGroup].sales | number:'1.0-0') }}
                              </div>
                            </ng-container>

                            <ng-container *ngSwitchCase="'cases'" class="cases-status">
                              <div class="cases-value">
                                {{ (location.solutions[solutionGroup].cases || 0) === '0' ? '-' : (location.solutions[solutionGroup].cases | number:'1.0-0') }}
                              </div>
                            </ng-container>
                          </ng-container>
                        </ng-container>

                        <!-- White status icon/text sets on hover -->
                        <ng-container *ngIf="(hoveredRowIndex === j && hoveredCellIndex === i)" class="hover-status-icons">
                          <div [ngSwitch]="tabSelected" class="white-status-icon">
                            <ng-container *ngSwitchCase="'compliance'">
                              <div [ngSwitch]="location.solutions[solutionGroup].status">
                                <img *ngSwitchCase="'Green'" src="assets/solution-participation/check-icon-white.svg" alt="white-checkmark-icon" class="status-icon white-icon">
                                <img *ngSwitchCase="'Yellow'" src="assets/solution-participation/warning-icon-white.svg" alt="white-warning-icon" class="status-icon white-icon">
                                <img *ngSwitchCase="'Red'" src="assets/solution-participation/close-icon-white.svg" alt="white-cross-icon" class="status-icon white-icon">
                              </div>
                            </ng-container>

                            <ng-container *ngSwitchCase="'sales'" class="sales-status">
                              <div class="sales-value">
                                {{ (location.solutions[solutionGroup].sales || 0) === '0' ? '-' : (currencyCode | currencySymbol) + (location.solutions[solutionGroup].sales | number:'1.0-0') }}
                              </div>
                            </ng-container>

                            <ng-container *ngSwitchCase="'cases'" class="cases-status">
                              <div class="cases-value">
                                {{ (location.solutions[solutionGroup].cases || 0) === '0' ? '-' : (location.solutions[solutionGroup].cases | number:'1.0-0') }}
                              </div>
                            </ng-container>
                          </div>

                          <div class="white-expand-icon">
                            <img src="assets/solution-participation/chevron-down-white.svg" alt="chevron-icon" class="chevron-icon">
                          </div>
                        </ng-container>

                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <!-- The header is placed later as we need the scrollbar on top and this is a hack to do it as its against browser functionality
              Stackoverflow: Q#-316384, Open Issue: https://github.com/w3c/csswg-drafts/issues/1293-->
          <!-- Table header Right section -->
          <div class="header-section">
            <ng-container *ngFor="let solutionGroup of solutionGroupNames">
              <div class="solution-group-header header-column" [ngClass]="{'sorted': sortBy === solutionGroup}">
                <div class="solution-name">{{solutionGroup}}</div>
                <span class="sort-arrow" [attr.data-id]="'sort-arrow-solution-group-j'" (click)="toggleSortDirection(solutionGroup)">
                  <img class="sort-arrow-img" [ngClass]="{'up': sortDirections[solutionGroup] == 'asc', 'down': sortDirections[solutionGroup] == 'desc' }" src="assets/blue-arrow.svg" alt="sort-arrow" />
                </span>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</section>

<!-- Handle the case where No Data is available -->
<ng-template #noData>
  <div class="message-block" *ngIf="!multipleContractsSelected && !multipleRebatesExistForContract">
    No Data Available
  </div>
</ng-template>

<!-- Handle Message for widgets when Multiple Accounts are selected -->
<ng-container *ngIf="!showTableLoader && multipleContractsSelected && selectedWidgetType !== 'all'">
  <div class="message-block">
    {{multipleHierarchiesSelectedMessage}}
  </div>
</ng-container>

<!-- Handle Message for Rebate when there are No Agreements -->
<ng-container *ngIf="!showTableLoader && !multipleContractsSelected && !eligibleForRebate && selectedWidgetType == 'rebate'">
  <div class="message-block">
    No Agreements - Not applicable
  </div>
</ng-container>

<!-- Handle Message when a contract has multiple agreements -->
<ng-container *ngIf="!showTableLoader && !multipleContractsSelected && multipleRebatesExistForContract && selectedWidgetType == 'rebate'">
  <div class="message-block">
    Rebate information is not shown because multiple rebates are associated with this item. Please contact the Finance team for details.
  </div>
</ng-container>

<!-- Locations table loader -->
<ng-template #tableloader>
  <div class="loader">
      <loader class="ml-10 mt-6" [size]="'medium'">
      </loader>
  </div>
</ng-template>

<!-- Modals with static content for Total Purchased Solution Groups and Individual Solution Groups -->
<ng-container *ngIf="showLocationViewModal">
  <div class="modal-backdrop" (click)="closeSolutionModal()" ></div>

  <!-- Individual Solution Groups modal with products for right section-->
  <ng-container *ngIf="showSolutionGroupModal">
    <div class="solution-group-modal-container">
      <div class="solution-modal" *ngIf="!isModalDataLoading; else modalLoader">
        <div class="solution-overview">
          <div class="solution-header">
            <h2 class="selected-solution-name">{{currentSelectedGroupForSite}}</h2>
            <div class="close-icon" (click)="closeSolutionModal()">
              <img src="assets/close-icon-dark-grey.svg" alt="Close icon" />
            </div>
          </div>

          <div class="product-overview" *ngIf="selectedSGProductCount != 0">
            <span class="product-count">Products: {{selectedSolutionGroupData?.countOfProducts}}</span> |
            <span class="distributor-status">Distributed by other: {{selectedSolutionGroupData?.otherDistributor ? 'Yes' : 'No'}}</span>
          </div>
        </div>
        <div class="horizontal-line">
          <hr />
        </div>
        <div class="solution-product-table" *ngIf="selectedSGProductCount != 0; else noProductsPurchased">
          <app-location-product-details-table
            (close)="showSolutionGroupModal = false"
            [productData]="selectedSolutionGroupData?.products" [rightSection]="true"
            [siteId]="currentSelectedSiteId"
            [siteName]="currentSelectedSiteName"
            [solutionGroup]="currentSelectedGroupForSite">
          </app-location-product-details-table>
        </div>
      </div>

    </div>
  </ng-container>

  <!-- Total Purchased Solution Groups modal for left section-->
  <ng-container *ngIf="showTotalSolutionGroupsModal">
    <div class="total-solution-group-modal-container">
      <div class="total-sp-modal-header">
        <h2>Solution Group</h2>
        <div class="close-icon" (click)="closeSolutionModal()">
          <img src="assets/close-icon-dark-grey.svg" alt="Close icon" />
        </div>
      </div>

      <div class="horizontal-line">
        <hr />
      </div>

      <div class="total-solutions-grid" *ngIf="!isModalDataLoading; else modalLoader">
        <app-location-total-solutions-grid
          (close)="closeSolutionModal()"
          [siteData]="totalSolutionGroupsForSiteData"
          [siteId]="currentSelectedSiteId"
          [siteName] = "currentSelectedSiteName"
          [totalSolutionGroups]="totalSolutionGroupsPurchased">
        </app-location-total-solutions-grid>
      </div>

    </div>
  </ng-container>

  <!-- Loader for Solution Group Modal -->
  <ng-template #modalLoader>
    <div class="solution-group-modal">
      <div class="loader">
        <loader class="ml-10 mt-6" [size]="'medium'">
        </loader>
      </div>
    </div>
  </ng-template>

  <!-- No Products Purchased for individual solution group-->
  <ng-template #noProductsPurchased>
      <div class="no-products-purchased">
        <h2>No sales data for this solution group for the time period selected.</h2>
      </div>
  </ng-template>
</ng-container>
</div>
